import { createB2bOffersSdk } from '@invivoretail/module-offers-sdk'
import { useAuthService } from '@b2ag/auth'
import { buildCallerId } from '@invivodf/front-seller-caller-id'
import fileService from '@invivodf/common/src/contexts/parameters/file.service'
import { productSdk, productSdkWithTimeout } from '@/core/dependency-injection'
import SalesStoresService from './salesStores.service'
import UserService from './user.service'
import ProductService from './product.service'
import OfferService from './offer.service'
import QuotaService from './quota/quota.service'
import StockMovementService from './stock-movement.service'
import StockService from './stock.service'
import ThresholdsStockService from './thresholdsStock/thresholds-stock.service'
import CooperativeVariantService from './cooperative-variant.service'
import CooperativeService from './cooperative.service'
import ShippingRatesService from './shipping-rates.service'
import ImportService from './import.service'
import MembershipService from './membership.service'
import TechnicalSaleService from './technical-sale.service'
import StoreService from './store.service'
import ElectronicInvoicingAddressesService from './electronic-invoicing-addresses.service'
import ShippingAddressesService from './shipping-addresses.service'
import ImportReportsService from './import-reports/import-reports.service'
import ZoneService from './zone.service'
import PaymentDueDateService from './payment-due-date/payment-due-date.service'
import SegmentService from './segment.service'
import ZoneChargesService from './zone-charges.service'
import StripeDashboardRedirect from './stripe-dashboard-redirect.service'
import UsagesService from './usages.service'
import PartnerContactService from './partner-contact.service'
import ProductsAdditionalDataService from './products-additional-data.service'
import CustomerStoreService from './customers-stores.service'
import UsersRolesService from './usersRoles.service'
import VariantSegmentationService from './variant-segmentation.service'

window.env = window.env || {}

const userApiHost = window.env.USER_API_HOST
const productApiHost = window.env.PRODUCT_API_HOST
const offersBffApiHost = window.env.OFFERS_BFF_API_HOST ?? ''
const quotaApiHost = window.env.QUOTA_API_HOST
const orderApiHost = window.env.ORDER_API_HOST
const membershipApiHost = window.env.MEMBERSHIP_API_HOST
const storeApiHost = window.env.STORE_API_HOST
const discountApiHost = window.env.DISCOUNT_API_HOST
const zoneChargesApiHost = window.env.ZONE_CHARGES_API_HOST
const zoneApiHost = window.env.ZONE_API_HOST
const paymentDueDateApiHost = window.env.PAYMENT_DUE_DATE_API_HOST
const usagesApiHost = window.env.USAGES_API_HOST
const wishlistApiHost = window.env.WISHLIST_API_HOST

const cooperativeService = new CooperativeService({ userApiHost })
const userService = new UserService({ userApiHost })
const productService = new ProductService({ productSdk })
const b2bOffersSdk = createB2bOffersSdk(offersBffApiHost, {
  accessTokenSource: () => useAuthService().getAccessToken(),
  callerId: buildCallerId(),
})
const offerService = new OfferService({ productApiHost, b2bOffersSdk })
const quotaService = new QuotaService({ quotaApiHost })
const stockMovementService = new StockMovementService({ productApiHost })
const stockService = new StockService({ orderApiHost })
const cooperativeVariantService = new CooperativeVariantService({ productSdk, productSdkWithTimeout })
const shippingRatesService = new ShippingRatesService({ orderApiHost })
const importService = new ImportService()
const membershipService = new MembershipService(membershipApiHost)
const technicalSaleService = new TechnicalSaleService(membershipApiHost)
const storeService = new StoreService(storeApiHost)
const shippingAddressesService = new ShippingAddressesService(membershipApiHost)
const electronicInvoicingAddressesService = new ElectronicInvoicingAddressesService(membershipApiHost ?? '')
const importReportsService = new ImportReportsService(
  membershipApiHost,
  productApiHost,
  orderApiHost,
  discountApiHost,
  wishlistApiHost,
  productSdk,
)
const zoneService = new ZoneService({ zoneApiHost })
const segmentService = new SegmentService({ userApiHost })
const zoneChargesService = new ZoneChargesService({ zoneChargesApiHost, productSdk })
const stripeDashboardRedirect = new StripeDashboardRedirect({ orderApiHost })
const paymentDueDateService = new PaymentDueDateService({ paymentDueDateApiHost })
const thresholdsStockService = new ThresholdsStockService({ orderApiHost })
const usagesService = new UsagesService({ usagesApiHost })
const partnerContactService = new PartnerContactService(membershipApiHost)
const productsAdditionalDataService = new ProductsAdditionalDataService(productSdk, productSdkWithTimeout)
const customerStoreService = new CustomerStoreService(productApiHost)
const variantSegmentationService = new VariantSegmentationService(productSdk)
const usersRolesService = new UsersRolesService(membershipApiHost ?? '')
const salesStoresService = new SalesStoresService(membershipApiHost ?? '')

export default usagesService

export {
  productService,
  cooperativeService,
  userService,
  offerService,
  quotaService,
  stockMovementService,
  stockService,
  cooperativeVariantService,
  variantSegmentationService,
  shippingRatesService,
  importService,
  membershipService,
  technicalSaleService,
  segmentService,
  storeService,
  shippingAddressesService,
  electronicInvoicingAddressesService,
  fileService,
  importReportsService,
  zoneService,
  zoneChargesService,
  paymentDueDateService,
  stripeDashboardRedirect,
  thresholdsStockService,
  usagesService,
  partnerContactService,
  productsAdditionalDataService,
  customerStoreService,
  usersRolesService,
  salesStoresService,
}
